import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-flip-to-back",
  templateUrl: "./med-icon-flip-to-back.component.html",
})
export class MedIconFlipToBackComponent extends SvgMixinComponent {}
